import React from 'react';
import { connect } from 'react-redux';
import { addOrRemoveFromComparison, fetchComparison } from '../reducer';
import { Button, Card } from 'antd';
import CartLine from './CartLine';
import { CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import loadable from '@loadable/component';

import '../css/ComparisonPopup.less';

const AnimateHeight = loadable(() => import('react-animate-height'));

class ComparisonPopup extends React.Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.state = {
            comparisonProducts: [],
            numberOfItems: null,
            detail: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchComparison());
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.setState(this.props);
        }
    }

    getProducts = () => {
        let products = [];
        this.state.comparisonProducts.forEach((oneItem) => {
            products.push(
                <CartLine
                    price={oneItem.formattedPrice}
                    name={oneItem.prodName}
                    image={oneItem.prodImgSrc}
                    productId={oneItem.prodId}
                    basketId={oneItem.basketId}
                    removeProduct={(e, id) => this.props.dispatch(addOrRemoveFromComparison(e, id))}
                />
            );
        });
        return products;
    };

    toggleDetail = () => {
        this.setState({
            detail: !this.state.detail,
        });
    };

    render() {
        if (this.state.comparisonProducts.length === 0) return '';
        return (
            <Card id={'comparison-popup'}>
                <div className={'toggle-detail'} onClick={this.toggleDetail}>
                    {this.state.detail ? <DownOutlined /> : <UpOutlined />}
                </div>
                <AnimateHeight
                    duration={300}
                    height={this.state.detail ? 'auto' : 0}
                    id={'comparison-popup-products'}
                >
                    <div>{this.getProducts()}</div>
                    <div id={'remove-all-comparison'}>
                        <Button
                            type={'link'}
                            onClick={(e) =>
                                this.props.dispatch(addOrRemoveFromComparison(e, 0, true))
                            }
                        >
                            Fjarlægja allar vörur <CloseOutlined />
                        </Button>
                    </div>
                </AnimateHeight>
                <div id={'comparison-footer'}>
                    {this.state.numberOfItems} {this.state.numberOfItems === 1 ? 'vara' : 'vörur'} í
                    samanburði
                    <Button href={'ShowComparison'} className={'origo-button small'}>
                        Skoða samanburð
                    </Button>
                </div>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    if (state.comparison.products) {
        return {
            comparisonProducts: state.comparison.products,
            numberOfItems: state.comparison.numberOfItems,
        };
    } else return {};
};

export default connect(mapStateToProps, null)(ComparisonPopup);
